import { render, staticRenderFns } from "./BodyWeight.vue?vue&type=template&id=0f37751c&"
import script from "./BodyWeight.vue?vue&type=script&lang=js&"
export * from "./BodyWeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports